import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Platform } from '@ionic/angular';
import { appConfig } from 'src/app/config/app.config';
import { Employee } from 'src/app/models/Employees';
import { Relative } from 'src/app/models/Relative';
import { AuthService } from 'src/app/services/auth.service';
import { ContactsService } from 'src/app/services/contacts.service';
import { EmployeeSService } from 'src/app/services/modelService/employeeS.service';
import { RelativeService } from 'src/app/services/modelService/relative.service';
import { TranslateService } from 'src/app/services/translate.service';
import { AlertService } from 'src/app/util/alert.service';
import { ToastService } from 'src/app/util/toast.service';
import { UtilityService } from 'src/app/util/utility.service';
import { CountryService } from 'src/app/services/country.service';

@Component({
  selector: 'app-add-relative',
  templateUrl: './add-relative.component.html',
  styleUrls: ['./add-relative.component.scss'],
})
export class AddRelativeComponent implements OnInit {
  isLive: boolean = true;
  utilityService: UtilityService = new UtilityService();
  minDate: string;
  maxDate: string;
  objectKeys = Object.keys;
  age: number;

  showMarital: boolean = true;

  @Input() emp: Employee = new Employee();
  @Input() relation: Relative = new Relative();
  @Output() mobileBlur = new EventEmitter<string>();

  constructor(private empService: EmployeeSService,
    private alert: AlertService,
    private contactsService: ContactsService, public trans: TranslateService,
    private relativeService: RelativeService, public auth: AuthService,
    public toastService: ToastService, public platform: Platform,
    public countryService: CountryService) {
    this.trans.translateObjList(this.utilityService.educationObjectList);
  }

  ngOnInit() {
    const currentDate = new Date();
    this.maxDate = currentDate.toISOString().split('T')[0];
    this.updateDateLimits()
    console.log("8*************", this.emp.user.user_pd);
    this.onDobChange(this.emp.user.dob);
    if (this.relation.relation == 'Father' || this.relation.relation == 'Mother' || this.relation.relation == 'Husband' || this.relation.relation == 'Wife' || this.relation.relation == 'Wif') {
      this.showMarital = false;
    }

    if (this.emp?.user?.user_pd?.mobile) {
      const parsed = this.countryService.parsePhone(this.emp.user.user_pd.mobile);
      if (parsed) {
        this.emp.user.user_pd.country_code = parsed.countryCode;
        this.emp.user.user_pd.mobile = parsed.number;
      }
    } else if (this.emp?.user?.user_pd && !this.emp.user.user_pd.country_code) {
      this.emp.user.user_pd.country_code = '+91'; // Default
    }

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['emp'] && changes['emp'].currentValue) {
      this.updateDateLimits();
    }
  }
  updateDateLimits() {
    if (this.emp && this.emp.user.dob) {
      const dobDate = new Date(this.emp.user.dob);
      this.minDate = dobDate.toISOString().split('T')[0];
    } else {
      this.minDate = '';
    }
    if (this.emp.user.user_pd.death_date) {
      this.isLive = false;
    }
    console.log(this.minDate, " ...", this.maxDate)
  }
  afterUpload(url) {
    console.log(url);
    this.emp.user.url = url;
    this.empService.saveUser(appConfig.STORAGE_TABLE.USER, this.emp.user).then(() => {
      this.relativeService.getRelative(this.emp.id, "relative_id").then(async (relativeList: Relative[]) => {
        for (let relative of relativeList) {
          relative.url = url;
        }
        await this.relativeService.saveObjectList(relativeList);

      })
    })
  }

  onClickContact() {

    this.contactsService.getContacts().then(async (cont: any) => {
      if (cont && cont.length > 0) {
        // this.toastService.warning(JSON.stringify(cont));
        if (cont[0].tel.length > 0) {
          this.emp.user.user_pd.mobile = cont[0].tel[0].replaceAll(" ", "").replace("-", "").slice(-10);
        }
        let nameArray = cont[0].name[0].split(" ");
        this.emp.user.name = nameArray[0];
      }
    })
  }
  assumeDate() {
    if (!this.emp.user.dob) {
      if (this.emp.user.user_pd.marital == 'Married') {
        this.emp.user.dob = new Date(new Date().getTime() - (35 * 31556926000));
      } else {
        this.emp.user.dob = new Date(new Date().getTime() - (15 * 31556926000));
      }
    }
  }

  onBlurMobile() {
    if (!this.emp?.user?.user_pd?.mobile || this.emp.user.user_pd.mobile.trim().length === 0) {
      this.emp.user.user_pd.mobile = null;
    }

    if (this.emp?.user?.user_pd?.mobile) {
      if (this.emp.user.user_pd.mobile.startsWith("+")) {
        this.mobileBlur.emit(this.emp.user.user_pd.mobile);
      } else {
        this.emp.user.user_pd.mobile = this.emp.user.user_pd.country_code + this.emp.user.user_pd.mobile;
        this.mobileBlur.emit(this.emp.user.user_pd.mobile);
      }
    }
  }

  clickAddAchievements(item) {
    if (!item) {
      item = {};
    }
    this.alert.show2TextAlert(this.trans.translate("Achievements / Posts"), this.trans.translate("Tell us about your achievements or roles — share your field and rank/designation to inspire others!"), this.trans.translate("Field"), this.trans.translate("Position"), this.trans.translate("Add"), this.trans.translate("Cancel"), Object.keys(item)[0], item[Object.keys(item)[0]]).then((data) => {
      if (data.length == 2) {
        if (!this.emp.user.user_pd.achievement) {
          this.emp.user.user_pd.achievement = [];
        }
        if (Object.keys(item).length == 0) {
          this.emp.user.user_pd.achievement.push({ [data[0]]: data[1] });
        } else {
          item[Object.keys(item)[0]] = data[1];
        }

      } else {
        this.toastService.warning(this.trans.translate("Please enter both field and position"));
      }
    })
  }
  deleteAchievement(item) {
    this.alert.showAlert(this.trans.translate("Delete"), this.trans.translate("Are you sure you want to delete this item?"), this.trans.translate("Yes"), this.trans.translate("Cancel")).then((data) => {
      this.emp.user.user_pd.achievement.splice(this.emp.user.user_pd.achievement.indexOf(item), 1);
    });
  }

  onAgeChange(event: any) {
    if (this.age && this.age > 0) {
      const today = new Date();
      const dobYear = today.getFullYear() - this.age;
      const dob = new Date(dobYear, today.getMonth(), today.getDate());
      this.emp.user.dob = dob;
    }
  }
  onDobChange(dob: any) {
    if (dob) {
      const today = new Date();
      const birthDate = new Date(dob);
      this.age = today.getFullYear() - birthDate.getFullYear();
    }
  }

}
